// ตัวช่วยจัดการ filter ที่เก็บไว้บน url (ใช้แบบเดียวกับหน้า Mail history)
// เก็บไว้บน url เพื่อให้ refresh หรือกดย้อนกลับมาแล้ว filter / เลขหน้ายังอยู่

// แปลง query string เป็น state ของ filter
// - fields คือคีย์ที่ยอมให้อยู่บน url ได้ (กันค่าแปลกปลอมหลุดเข้าไปใน query ที่ยิง api)
// - ค่าว่างจะถูกตัดทิ้ง
export const parseFilterQuery = (search, fields) => {
  const searchParams = new URLSearchParams(search || '');
  const currentPage = Number(searchParams.get('page')) || 1;
  let filterValues = {};
  fields.forEach((key) => {
    filterValues[key] = searchParams.get(key) || '';
  });
  Array.from(searchParams.keys()).forEach((key) => {
    if (fields.indexOf(key) === -1 || !searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : '',
    filterValues,
    currentPage,
  };
};

// เขียน filter + เลขหน้ากลับขึ้น url (replace ไม่เพิ่ม history)
export const syncFilterUrlQuery = (router, query, page) => {
  const searchParams = new URLSearchParams(query || '');
  Array.from(searchParams.keys()).forEach((key) => {
    if (!searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  if (page > 1) {
    searchParams.set('page', page);
  }
  const search = searchParams.toString();
  router.navigate({ search: search ? `?${search}` : '' }, { replace: true });
};
